module.exports = __webpack_public_path__ + "static/media/bubbles.c9285e5f.png";